module.exports = __webpack_public_path__ + "1198491bd87b5c9552160e3697a85f70.fbx";